import React, { useState, useMemo } from 'react';
import axios from 'axios';
import SingleItemDetailTemplate from '../../../Reusable_Components/SingleItemDetailTemplate';
import { useParams, useNavigate } from 'react-router-dom';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import { ToastContext } from '../../../../context/ToastContext';
import ConfirmModal from '../../../Reusable_Components/ConfirmModal';
import useDetailFetch from '../../../../hooks/useDetailFetch';

const SingleScheduledReportDetails = () => {
  const { scheduledReportId } = useParams();
  const navigate = useNavigate();
  const { showToast } = React.useContext(ToastContext);

  const decodedId = scheduledReportId ? atob(scheduledReportId) : scheduledReportId;
  const id = decodedId.replace(/\D/g, '');
  const [showDelete, setShowDelete] = useState(false);

  const url = id ? `${API_DOMAIN}${API_ROUTES['scheduledReport']}${id}/` : null;
  const { data: details, loading } = useDetailFetch(url);

  const columns = useMemo(() => {
    if (!details) return null;
    const excluded = ['id', 'updated_at', 'created_at'];
    return Object.keys(details)
      .filter(c => !excluded.includes(c))
      .map(c => ({ label: c.charAt(0).toUpperCase() + c.slice(1), field: c }));
  }, [details]);

  const handleDelete = async () => {
    try {
      await axios.delete(API_DOMAIN + API_ROUTES['scheduledReport'] + id + '/', { headers });
      showToast('Scheduled Report deleted successfully', 'success');
      navigate('/reporting/scheduled-report/list');
    } catch (error) {
      console.error('Error deleting ScheduledReport:', error);
      showToast('Failed to delete Scheduled Report', 'error');
    }
  };

  return (
    <div>
      <SingleItemDetailTemplate
        details={details}
        columns={columns}
        loading={loading}
        entityName="Scheduled Report"
        listPath="/reporting/scheduled-report/list"
        editPath={`/reporting/scheduled-report/input/${btoa(id)}`}
        onDelete={() => setShowDelete(true)}
      />
      <ConfirmModal
        isOpen={showDelete}
        title="Delete Scheduled Report"
        message="Are you sure you want to delete this scheduled report?"
        onConfirm={handleDelete}
        onCancel={() => setShowDelete(false)}
      />
    </div>
  );
};

export default SingleScheduledReportDetails;
